    import {Modal} from 'react-bootstrap'
import {PaymentWidget} from 'package-bundle'
import { useEffect, useState } from 'react'
import { useLang } from '../../i18n/OpenSooqi18n'
import generate_jwt from '../../../libs/jwt/jwt'
import { KTSVG } from '../../helpers'
import Swal from 'sweetalert2'
import { useIntl } from 'react-intl'
import 'package-bundle/dist/esm/css/Main.import.css'
import { checkIfLogin, getCookies, logout } from '../../helpers/commonFunctions'
type Props = {
  show: boolean
  handleClose: () => void
  type : string[]
  id?: number
  pos : string
}

const BundleModal = ({show,handleClose,type,id,pos}: Props) => {
    const Intl = useIntl()
    const lang = useLang();
    const cookiesData = getCookies()
    const memberInfo = cookiesData.userInfo;
    const [newToken,setNewToken] = useState<string>('')
    useEffect(() => {
        generatedToken().then((token) => {
            setNewToken(token ?? '');
        })
    },[])
    
    const generatedToken = (async () => {
        if(memberInfo && memberInfo.id){
            const memberId = memberInfo.id
            const token = generate_jwt(Number(cookiesData.tgtTimestamp),cookiesData.tgtTicket,memberId.toString())
            return token;
        }else{
            logout();
        }
    })

    const closeModal = () => {
        handleClose()
    }
    
    const isMobile = window.innerWidth <= 800
    return <>
        <Modal id='iframe'tabIndex={-1} aria-hidden='true'   dialogClassName={`modal-dialog modal-dialog-centered ${(isMobile) ? 'modal-fullscreen' : 'modal-lg'}`} show={show}  style={{overflowY:"scroll"}}onHide={closeModal}>
            <div className='modal-header p-5 border-bottom-0'>
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closeModal}>
                    <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                </div>
            </div>
            <div className='modal-content px-5 overflow-scroll'>
                {newToken && <PaymentWidget pos_source={pos}  products={type ?? []} modelId={id ?? 0} token={newToken ?? ''} language={lang} domain={window.location.hostname} api={process.env.REACT_APP_OPENSOOQ_API_URL_BASE + 'v2.1' ?? ''}  source={'desktop'} countryAbbreviation={cookiesData.ecountry ?? 'jo'}/>}
            </div>
        </Modal>
    </>
}

export {BundleModal}